import { AbstractControl, ValidatorFn } from '@angular/forms';

export function customPatternValidator(type: any, dataField: any): ValidatorFn {
  let pattern: RegExp;
  if (type === 'numeric') {
    pattern = /^[0-9]*$/;
  } else if (type === 'email') {
    pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  }
  else if(type === 'companyEmail'){
    pattern  = /^[a-zA-Z0-9._%+-]+@(spitex-march\.ch|sanesquare\.com)$/;
  }

  return (control: AbstractControl): { [key: string]: any } | null => {
    const formGroup = control.parent;
    const formControl = formGroup?.get(dataField);
    if (!formControl) {
      return null; // If the control doesn't exist, return null
    }
    const data = formControl?.value;
    const isValid = pattern.test(data);
    if (data !== '' && !isValid) {
      return { invalid: true }; // pattern is invalid
    }
    return null; // pattern is valid
  };
}

//set placeholder wrt the selected country code
export function phoneNumberValidation(countryCode:string){
  let phoneNumPattern:string = ''
  switch (countryCode) {
    case '+1': // US & Canada
      phoneNumPattern = '1234567890' // 10 digits
      break;
    case '+44': // United Kingdom
      phoneNumPattern = '134556798'
      break;
    case '+61': // Australia
      phoneNumPattern = '0412345678'
      break;
    case '+91': // India
      phoneNumPattern = '1234567890' // 10 digits
      break;
    case '+49': // Germany
      phoneNumPattern = '0234567890' // Varies
      break;
      case '+33': // France
      // Validating 10 digits format (can be with or without spaces)
     phoneNumPattern = '0239867890'
      break;
    case '+81': // Japan
      phoneNumPattern = '09012345678'
      break;
    case '+55': // Brazil
      phoneNumPattern = '11987654321'
      break;
    case '+27': // South Africa
      phoneNumPattern = '08823456789'
      break;
    case '+7': // Russia
      phoneNumPattern = '9123456789'
      break;
    case '+52': // Mexico
      phoneNumPattern = '5512345678'
      break;
    case '+39': // Italy
      phoneNumPattern = '098234567'
      break;
    case '+31': // Netherlands
      phoneNumPattern = '0620874518'
      break;
    case '+34': // Spain
     phoneNumPattern = '712345678' // 9 digits
      break;
    case '+64': // New Zealand
      phoneNumPattern = '0223456788'
      break;
    case '+41': // Switzerland
      phoneNumPattern = '0123456789'
      break;
    default:
      phoneNumPattern = ''; // If country code is not recognized
  }
  return phoneNumPattern
}
// this check whether the entered values fall within the range 1 and 12.
export function monthRangeValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    // If the field is empty, mark it as invalid (to trigger red border)
    if (value === null || value === undefined || value === '') {
      return { required: true }; // Use 'required' to indicate an empty field
    }
    // Convert value to a number
    const numValue = Number(value);

    // Ensure value is within 1-12 range
    if (isNaN(value) || value < 1 || value > 12||!Number.isInteger(numValue)) {
      return { invalidMonth: true };
    }
    return null;
  };
}
